module.exports = __webpack_public_path__ + "img/banner1.66b2492f.png";